import { IApplicationState } from '../../../../types/types';
import { ILibTheme } from '../types';

export const getLibThemes = (
    state: IApplicationState
): ILibTheme[]  => {
    return (state.model.libThemes && state.model.libThemes.list) || [];
}
